export default __webpack_public_path__ + "static/media/healthy-teeth.418c5599.png";